module.exports = __webpack_public_path__ + "static/media/logo-pumarin.714e01a1.jpg";